// extracted by mini-css-extract-plugin
export default {"leadertitle":"RysCoversation_leadertitle__5EzZ+"};